import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageHeaderProps {
  breadcrumbs: BreadcrumbItem[];
  actions?: React.ReactNode;
}

export function PageHeader({ breadcrumbs, actions }: PageHeaderProps) {
  const [centerNode, setCenterNode] = useState<HTMLElement | null>(null);
  const [actionsNode, setActionsNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setCenterNode(document.getElementById('global-header-center'));
    setActionsNode(document.getElementById('global-header-actions'));
  }, []);

  const breadcrumbsContent = (
    <div className="hidden md:flex items-center text-sm px-4">
      {breadcrumbs.map((crumb, idx) => {
        const isLast = idx === breadcrumbs.length - 1;
        return (
          <React.Fragment key={idx}>
            {isLast ? (
              // The current location is the page's single <h1> — in-content titles
              // would duplicate it (they stay mobile-only, see org pages).
              <h1 className="font-semibold text-slate-800">{crumb.label}</h1>
            ) : (
              <>
                {/* Router Link, not a raw anchor: a raw <a href> makes every
                    breadcrumb click a full document reload — the whole app
                    reboots behind the full-screen loader. */}
                <Link to={crumb.href || '#'} className="text-slate-500 hover:text-slate-900">
                  {crumb.label}
                </Link>
                <span className="mx-2 text-slate-400">/</span>
              </>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );

  return (
    <>
      {centerNode && createPortal(breadcrumbsContent, centerNode)}
      {actionsNode && actions && createPortal(actions, actionsNode)}


    </>
  );
}
